import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoDialog from '../Dialog/InfoDialog';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { PayDriver,
    PayShop,
    PaySupplier,
    PaymentRecieved,
    PaymentFastag,
    TransactionHistory,
    TransactionPending
 } from '../TopCard/icons';
 import { numberFormat,getDateInStringDDMMMYYYY,getVehicleNumberValuesDWeb } from '../../../utils/utils';
const useStyles = makeStyles((theme) => ({
  paymentCard: {
      boxShadow:'none',
      borderRadius:8,
  },
  detailsDiv:{
      padding:16
  },
  detailsDiv1:{
      marginTop:24
  },
  successDiv:{
      display:'flex',
      padding:"12px 16px",
      alignItems:'center',
      backgroundColor:"#00885a",
      borderTopLeftRadius:8,
      borderTopRightRadius:8
  },
  pendingDiv:{
      display:'flex',
      padding:"12px 16px",
      alignItems:'center',
      backgroundColor:"#ffa462",
      borderTopLeftRadius:8,
      borderTopRightRadius:8
  },
  successIcon:{
      marginRight:16,
      color:"#fff"
  },
  pendingIcon:{
      marginRight:16,
      color:"#fff"
  },
  headerTxt:{
      fontSize:16,
      fontWeight:600,
      color:"#fff"
  },
  section:{
      marginBottom:16,
      display:'flex',
      flexDirection:'column',
      "&:last-child": {
        marginBottom: 0
      }
  },
  subTitleSec:{
      marginBottom:2,
      display:'flex',
      flexDirection:'row',
      justifyContent:'space-between',
      alignItems:'center'
  },
  valueSec:{
      display:'flex',
      flexDirection:'row',
      justifyContent:'space-between',
      alignItems:'center'
  },
  subTitleTxt:{
      fontSize:12,
      fontWeight:500,
      color: "rgba(11, 19, 35, 0.5)",
      textTransform:'capitalize'
  },
  vehileNumber: {
    fontSize: 14,
    "&:last-child": {
      color: '#0033cc',
      marginLeft: 6
    },
    "&:nth-last-child(2)": {
      marginLeft: 6
    }
  }
}));
const TripChargeDetailsCard = (props) => {
  const { 
      title,
      type,
      data,
      trip,
      journey,
      updateJourney,
    } = props;
  const classes = useStyles();
  const getPaymentStatus = (type)=>{
    switch (type) {
        case "SUCCESS":
            return <div className={classes.successDiv}>
                        <CheckCircleIcon className={classes.successIcon} />
                        <Typography className={classes.headerTxt}>Payment Successful</Typography>
                   </div>
        case "RELEASED":
            return <div className={classes.successDiv}>
                        <CheckCircleIcon className={classes.successIcon} />
                        <Typography className={classes.headerTxt}>Recharge Successful</Typography>
                   </div>
        case "REFUNDED":
            return <div className={classes.successDiv}>
                        <CheckCircleIcon className={classes.successIcon} />
                        <Typography className={classes.headerTxt}>Refund Successful</Typography>
                   </div>
        case "PENDING":
            return <div className={classes.pendingDiv}>
                    <TransactionPending className={classes.pendingIcon} />
                    <Typography className={classes.headerTxt}>Payment Pending</Typography>
                  </div>
        default:
            return ""
      }
  }
  const getSubTitle = (type)=>{
    switch (type) {
        case "vendor":
            return "Supplier Name";
        case "shop":
            return "Shop Name";
        case "driver":
            return "Driver Name";
        case "customer":
            return "Party Name";
        case "fastag":
            return "Vehicle Number";
        case "fuelcard":
            return "Vehicle Number";    
        default:
            return null
      }
  }
  const getSubPaymentType= (amount)=>{
    switch (amount) {
        case amount<0:
            return "Credit";
        case  amount>0:
            return "Payment";
        default:
            return null
      }
  }
  const getSubBankName = (type)=>{
    switch (type) {
        case "vendor":
            return "Supplier Bank";
        case "shop":
            return "Shop Bank";
        case "driver":
            return "Driver Bank";
        case "customer":
            return "Party Bank";
        case "fastag":
            return "Vehicle Number";
        case "fuelcard":
            return "Diesel Card";    
        default:
            return null
      }
  }
  return (
    <>
      <Paper className={classes.paymentCard}>
                <>
                    <div className={classes.detailsDiv}>
                        <div className={classes.section}>
                            <div className={classes.subTitleSec} >
                                <Typography className={classes.subTitleTxt}>Charge Type</Typography>
                                <Typography className={classes.subTitleTxt}>Charge Amount</Typography>
                            </div>
                            <div className={classes.valueSec}>
                                <Typography className={classes.valueTxt}>{data && data.displayName?data.displayName:""}</Typography>
                                <Typography className={classes.valueTxt}>{data && data.amount?numberFormat(Math.abs(data.amount)):""}</Typography>
                            </div>
                        </div>
                        <div className={classes.section}>
                            <div className={classes.subTitleSec} >
                                <Typography className={classes.subTitleTxt}>Charge Date</Typography>
                            </div>
                            <div className={classes.valueSec}>
                                <Typography className={classes.valueTxt}>{data && data.date?getDateInStringDDMMMYYYY(data.date):""}</Typography>
                            </div>
                        </div>
                        <div className={classes.section}>
                            <div className={classes.subTitleSec} >
                                <Typography className={classes.subTitleTxt}>Notes</Typography>
                            </div>
                            <div className={classes.valueSec}>
                                <Typography className={classes.valueTxt}>{data && data.description?data.description:"--"}</Typography>
                            </div>
                        </div>
                    </div>
                </>
      </Paper>
    </>
  );
}
export default TripChargeDetailsCard;